import { render } from "./appTeaTrainTask.vue?vue&type=template&id=26bdc392&scoped=true"
import script from "./appTeaTrainTask.vue?vue&type=script&lang=js"
export * from "./appTeaTrainTask.vue?vue&type=script&lang=js"

import "./appTeaTrainTask.vue?vue&type=style&index=0&id=26bdc392&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bdc392"]])

export default __exports__